module.exports = __webpack_public_path__ + "static/media/start-btn@2x.15d395b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/start-btn@2x.png
// module id = 819
// module chunks = 0